import { ShieldAlert, Info } from 'lucide-react';

export const AYVENS_CLIENT_MESSAGE =
  "In base alle direttive del mandante, i clienti con contratti Ayvens attivi o passati devono essere gestiti da un consulente dedicato per verificare la trasferibilità della posizione. Un nostro agente ti contatterà a breve.";

const STAFF_MESSAGE =
  "Potrai preparare il preventivo, ma il PDF uscirà senza dati anagrafici e l'invio email resterà bloccato fino alla verifica del censimento da parte della Sede.";

// Domanda obbligatoria SÌ/NO "Già cliente Ayvens / ALD Automotive"
export const AyvensQuestion = ({ value, onChange, variant = 'client', testIdPrefix = 'ayvens' }) => {
  const opt = (val, label) => (
    <button
      type="button"
      onClick={() => onChange(val)}
      data-testid={`${testIdPrefix}-${val ? 'si' : 'no'}`}
      className={`px-5 py-1.5 rounded-full text-sm font-semibold border transition-colors ${
        value === val
          ? (val ? 'bg-red-600 border-red-600 text-white' : 'bg-emerald-600 border-emerald-600 text-white')
          : 'bg-white border-slate-300 text-slate-600 hover:bg-slate-50'
      }`}
    >
      {label}
    </button>
  );
  return (
    <div className="space-y-2 rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid={`${testIdPrefix}-question`}>
      <p className="text-sm font-medium text-slate-800">
        Sei già cliente con contratti di noleggio attivi o passati con Ayvens / ALD Automotive? *
      </p>
      <div className="flex gap-2">
        {opt(true, 'SÌ')}
        {opt(false, 'NO')}
      </div>
      {value === true && (
        <div
          className={`flex gap-2 text-xs rounded-md p-2 ${variant === 'client' ? 'bg-blue-50 text-blue-800' : 'bg-amber-50 text-amber-800'}`}
          data-testid={`${testIdPrefix}-message`}
        >
          {variant === 'client' ? <Info className="w-4 h-4 shrink-0" /> : <ShieldAlert className="w-4 h-4 shrink-0" />}
          <span>{variant === 'client' ? AYVENS_CLIENT_MESSAGE : STAFF_MESSAGE}</span>
        </div>
      )}
    </div>
  );
};
